import './settings.css'

import { Container, Tabs } from '@mantine/core'
import { createFileRoute, Outlet, redirect, useMatches, useNavigate } from '@tanstack/react-router'

import { useUser } from '../../user-provider/user-context'

export const Route = createFileRoute('/app/settings')({
  component: SettingsComponent,
  beforeLoad: ({ location }) => {
    // Only redirect if we're exactly on /app/settings
    if (location.pathname === '/app/settings') {
      throw redirect({
        to: '/app/settings/branch-settings/general',
      })
    }
  },
})

function SettingsComponent() {
  const { isAdmin } = useUser()
  const navigate = useNavigate()
  const matches = useMatches()
  const activeTab = (() => {
    const match = matches.find((match) => match.pathname.startsWith('/app/settings/'))
    if (!match) return 'user-settings'

    const segments = match.pathname.split('/')
    if (segments.includes('branch-settings')) return 'branch-settings'
    if (segments.includes('business-settings')) return 'business-settings'
    if (segments.includes('user-management')) return 'user-management'
    if (segments.includes('user-settings')) return 'user-settings'

    return 'user-management'
  })()

  return (
    <Container size={1400} p="lg">
      <Tabs
        value={activeTab}
        defaultValue="user-management"
        onChange={(value) => {
          if (value === 'branch-settings') {
            navigate({ to: '/app/settings/branch-settings/general' })
          } else {
            navigate({ to: `/app/settings/${value}` })
          }
        }}
      >
        <Tabs.List>
          <Tabs.Tab value="branch-settings">Branch Settings</Tabs.Tab>
          {isAdmin && <Tabs.Tab value="business-settings">Business Settings</Tabs.Tab>}
          <Tabs.Tab value="user-management">User Management</Tabs.Tab>
          <Tabs.Tab value="user-settings">User Settings</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="branch-settings" pt="md">
          <Outlet />
        </Tabs.Panel>
        <Tabs.Panel value="business-settings" pt="md">
          <Outlet />
        </Tabs.Panel>
        <Tabs.Panel value="user-management" pt="md">
          <Outlet />
        </Tabs.Panel>
        <Tabs.Panel value="user-settings" pt="md">
          <Outlet />
        </Tabs.Panel>
      </Tabs>
    </Container>
  )
}
